import Workspace, {
  SelectedWorkspaceVersion,
  WorkspaceDocument,
} from "@/models/workspace/Workspace";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type WorkspaceDocumentVersionState = {
  workspaceDocument: WorkspaceDocument | null;
  workspace: Workspace | null;
  setWorkspaceDocument: (workspaceDocument: WorkspaceDocument) => void;
  setWorkspace: (workspace: Workspace) => void;
  selectedVersion: SelectedWorkspaceVersion | null;
  setSelectedVersion: (version: SelectedWorkspaceVersion | null) => void;
  resetWorkspaceDocumentVersionStore: () => void;
};

export const useWorkspaceDocumentVersionStore =
  create<WorkspaceDocumentVersionState>()(
    persist(
      (set) => ({
        workspaceDocument: null,
        workspace: null,
        selectedVersion: null,
        setWorkspaceDocument: (workspaceDocument: WorkspaceDocument) => {
          set({ workspaceDocument });
        },
        setWorkspace: (workspace: Workspace) => {
          set({ workspace });
        },
        setSelectedVersion: (version: SelectedWorkspaceVersion | null) => {
          set({ selectedVersion: version });
        },
        resetWorkspaceDocumentVersionStore: () => {
          set({
            workspaceDocument: null,
            workspace: null,
            selectedVersion: null,
          });
        },
      }),
      {
        name: "workspace-document-version-storage",
      }
    )
  );
